var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"aha-link",class:[
    `aha-link--${_vm.variant}`,
    `aha-link--${_vm.type}-type`,
    `aha-link--${_vm.size}`,
    {
      'ml-4': _vm.hasMarginLeft,
      'mr-4': _vm.hasMarginRight,
    },
  ],on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }